import licenseModule from '../../license.module';

export default licenseModule.component('licenseSubscriptionPlan', {
    template: require('./licenseSubscriptionPlan.component.html'),
    controller: [
        'asLoadingMask',
        'usageTypeConstants',
        'doughnutService',
        licenseSubscriptionPlanComponent
    ],
    bindToController: true,
    bindings: {
        cloudSubscriptionSummary: '<'
    }
});

function licenseSubscriptionPlanComponent(
    asLoadingMask,
    usageTypeConstants,
    doughnutService
) {
    var vm = this;
    vm.$onChanges = change;

    asLoadingMask.show();

    function getFlagMessage() {
        var endDate = vm.cloudSubscriptionSummary.endDate;
        var today = new Date();
        var timeDiff = Math.abs(today.getTime() - endDate.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        var wordDays = 'day';

        if (diffDays > 1) {
            wordDays = 'days';
        }

        vm.flagMessage =
            'Your subscription will expire in ' +
            diffDays +
            ' ' +
            wordDays +
            '. Please contact Appspace Support to renew/upgrade your subscription or your devices will stop receiving content updates.';
    }

    function recalculateDonutData() {
        if (vm.cloudSubscriptionSummary != null) {
            var cloudStorageUsedGB =
                vm.cloudSubscriptionSummary.storage.usage /
                (1024 * 1024 * 1024);

            var cloudStorageTotalGB =
                vm.cloudSubscriptionSummary.cloudStorageTotal /
                (1024 * 1024 * 1024);

            // storage
            var storageColor = doughnutService.getDoughnutColor(
                vm.cloudSubscriptionSummary.storage.alertLevel,
                usageTypeConstants.storage
            );
            var chart1 = {
                planName: vm.cloudSubscriptionSummary.plan,
                usage: cloudStorageUsedGB,
                total: cloudStorageTotalGB,
                unit: 'GB',
                cals: 0,
                color: storageColor,
                chartTitle: 'Cloud Storage',
                balanceMessage: 'remaining storage'
            };

            vm.chart1 = chart1;

            var cloudBandwidthUsedGB =
                vm.cloudSubscriptionSummary.bandwidthDetail.usage != null
                    ? vm.cloudSubscriptionSummary.bandwidthDetail.usage /
                      (1024 * 1024 * 1024)
                    : null;

            var cloudBandwidthTotalGB =
                vm.cloudSubscriptionSummary.cloudBandwidthTotal /
                (1024 * 1024 * 1024);

            var bandwidthColor = doughnutService.getDoughnutColor(
                vm.cloudSubscriptionSummary.bandwidthDetail.alertLevel,
                usageTypeConstants.bandwidth
            );

            var chart2 = {
                planName: vm.cloudSubscriptionSummary.plan,
                usage: cloudBandwidthUsedGB,
                total: cloudBandwidthTotalGB,
                unit: 'GB',
                cals: 0,
                color: bandwidthColor,
                chartTitle: 'Monthly Cloud Bandwidth',
                balanceMessage: 'remaining bandwidth'
            };

            vm.chart2 = chart2;
        }
    }

    function change(changeObj) {
        if (
            changeObj.cloudSubscriptionSummary.currentValue &&
            changeObj.cloudSubscriptionSummary.currentValue != null
        ) {
            recalculateDonutData();
            getFlagMessage();
            asLoadingMask.hide();
        }
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-subscription-plan/licenseSubscriptionPlan.component.js